import { render, staticRenderFns } from "./HistoricoProduto.vue?vue&type=template&id=b091b0ae&scoped=true&"
import script from "./HistoricoProduto.vue?vue&type=script&lang=js&"
export * from "./HistoricoProduto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b091b0ae",
  null
  
)

export default component.exports